// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

export function rfbClear(): ReducerAction {
	return {
		type: Types.RFB_CLEAR,
		payload: null,
	};
}
